import classes from './MiniSpinner.module.css';

const MiniSpinner = () => <div className={classes.loader}>Loading...</div>;

export default MiniSpinner;
